export type DomainKey = 'card' | 'ball'

export const DOMAINS: Array<{ key: DomainKey; label: string; emoji: string }> = [
  { key: 'card', label: '牌类', emoji: '🃏' },
  { key: 'ball', label: '球类', emoji: '🏓' },
]

export const GAME_LABELS: Record<string, string> = {
  guandan: '掼蛋',
  bridge: '桥牌',
  shuang_sheng: '双升',
  shuangkou: '双扣',
  zhong_hua_qiao_pai: '中华侨牌',
  doudizhu: '斗地主',
  pickleball: '匹克球',
  tennis: '网球',
  badminton: '羽毛球',
}

// 每个项目的图标与配色。iconBg / bar 用完整静态类名，避免 Tailwind purge。
export type GameMeta = { icon: string; iconBg: string; bar: string }

export const GAME_META: Record<string, GameMeta> = {
  // 白卡片 + gray-50 底的清爽体系:图标底色柔和 -100,左侧色条低饱和 -300,保留各项目辨识但不刺眼。
  // 完整静态类名,避免 Tailwind purge。
  guandan: { icon: '🥚', iconBg: 'bg-amber-100 text-amber-700', bar: 'bg-amber-300' },
  bridge: { icon: '♣️', iconBg: 'bg-slate-100 text-slate-600', bar: 'bg-slate-300' },
  shuang_sheng: { icon: '🔺', iconBg: 'bg-emerald-100 text-emerald-700', bar: 'bg-emerald-300' },
  shuangkou: { icon: '🎴', iconBg: 'bg-violet-100 text-violet-700', bar: 'bg-violet-300' },
  zhong_hua_qiao_pai: { icon: '🀄', iconBg: 'bg-rose-100 text-rose-600', bar: 'bg-rose-300' },
  doudizhu: { icon: '👑', iconBg: 'bg-amber-100 text-amber-700', bar: 'bg-amber-300' },
  pickleball: { icon: '', iconBg: 'bg-lime-100 text-lime-700', bar: 'bg-lime-300' },
  tennis: { icon: '🎾', iconBg: 'bg-yellow-100 text-yellow-700', bar: 'bg-yellow-300' },
  badminton: { icon: '🏸', iconBg: 'bg-sky-100 text-sky-700', bar: 'bg-sky-300' },
}

export const DEFAULT_GAME_META: GameMeta = {
  icon: '📄',
  iconBg: 'bg-gray-100 text-gray-600',
  bar: 'bg-gray-400',
}
